import { TtsLocale } from '../models/Base';

export type LanguageDetails = {
  displayName: string;
  nativeName: string;
};

export const languageDetails: Record<TtsLocale, LanguageDetails> = {
  [TtsLocale.SA]: { displayName: 'Arabic', nativeName: 'العَرَبِيَّة' },
  [TtsLocale.DE]: { displayName: 'German', nativeName: 'Deutsch' },
  [TtsLocale.AU]: {
    displayName: 'English (Australia)',
    nativeName: 'English (Australia)',
  },
  [TtsLocale.GB]: {
    displayName: 'English (United Kingdom)',
    nativeName: 'English (United Kingdom)',
  },
  [TtsLocale.US]: {
    displayName: 'English (United States)',
    nativeName: 'English (United States)',
  },
  [TtsLocale.ES]: { displayName: 'Spanish', nativeName: 'Español' },
  [TtsLocale.FR]: { displayName: 'French', nativeName: 'Français' },
  [TtsLocale.GR]: { displayName: 'Greek', nativeName: 'ελληνικά' },
  [TtsLocale.IL]: { displayName: 'Hebrew', nativeName: 'עִברִית' },
  [TtsLocale.IT]: { displayName: 'Italian', nativeName: 'Italiano' },
  [TtsLocale.JP]: { displayName: 'Japanese', nativeName: '日本語' },
  [TtsLocale.KR]: { displayName: 'Korean', nativeName: '한국인' },
  [TtsLocale.PT]: { displayName: 'Portuguese', nativeName: 'Português' },
  [TtsLocale.RU]: { displayName: 'Russian', nativeName: 'Русский язык' },
  [TtsLocale.CN]: {
    displayName: 'Chinese (Simplified)',
    nativeName: '简体中文',
  },
  [TtsLocale.HK]: {
    displayName: 'Chinese (Hong Kong)',
    nativeName: '繁體中文(香港)',
  },
  [TtsLocale.TW]: {
    displayName: 'Chinese (Taiwan)',
    nativeName: '繁體中文(台灣)',
  },
};

export const getLanguageDetail = (locale: TtsLocale | undefined) => {
  if (locale) {
    return languageDetails[locale];
  }
  return undefined;
};
